const createBannerBoxTokens = ({ radii }) => ({
  radii: {
    borderRadius: radii[0],
  },
});

export default createBannerBoxTokens;
